//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _willRemove_item_reasonCode_wiseId from './willRemove_item_reasonCode_wiseId';
export const willRemove_item_reasonCode_wiseId = _willRemove_item_reasonCode_wiseId;
export default {willRemove_item_reasonCode_wiseId};

